module.exports = __webpack_public_path__ + "img/23.7ac1d97e.jpg";